import { tns } from '../../../../node_modules/tiny-slider/src/tiny-slider';

const sliderElement = document.querySelectorAll('.o-stage');

// set same height on each slide
function setSameHeight() {
  sliderElement.forEach((value) => {
    const sliderElements = value.querySelectorAll('.o-stage__slider-element');
    let maxHeight = 0;

    // get max height
    sliderElements.forEach((v) => {
      const element = v;

      // reset height
      element.style.height = null;

      // get height
      const height = v.offsetHeight;
      if (height > maxHeight) {
        maxHeight = height;
      }
    });

    // set height
    sliderElements.forEach((v) => {
      const element = v;

      element.style.height = `${maxHeight}px`;
    });
  });
}

sliderElement.forEach((Slider) => {
  // Define Elements
  const sliderWrapper = Slider.querySelector('.o-stage__slider-wrapper');
  const controlContainer = Slider.querySelector('.o-stage__slider-controls');
  const controlPrevButton = Slider.querySelector('.o-stage__control-prev');
  const controlNextButton = Slider.querySelector('.o-stage__control-next');
  const sliderPagination = Slider.querySelector('.o-stage__pagination');
  const sliderElementsCount = Slider.querySelectorAll('.o-stage__slider-element').length;

  // collect data for Pagination
  if (sliderElementsCount > 1) {
    const paginationData = [];
    Slider.querySelectorAll('.o-stage__slider-element').forEach((v) => {
      const { paginationTitle } = v.dataset;
      paginationData.push(paginationTitle);
    });

    // build pagination Markup
    let paginationMarkup = '<ul>';
    paginationData.forEach((value, index) => {
      paginationMarkup += `<li><a class="o-stage__pagination-item ${index === 0 ? 'active' : ''}" data-slide="${index}">${value}</a></li>`;
    });
    paginationMarkup += '</ul>';

    // set tab index
    sliderWrapper.querySelectorAll('.a-link').forEach((v) => {
      const sliderLinks = v;

      sliderLinks.tabIndex = -1;
    });
    sliderWrapper.querySelectorAll('.a-link')[0].removeAttribute('tabindex');


    // Init Slider
    const stageSlider = tns({
      container: sliderWrapper,
      items: 1,
      slideBy: 'page',
      autoplay: false,
      autoHeight: true,
      controlsContainer: controlContainer,
      prevButton: controlPrevButton,
      nextButton: controlNextButton,
      mode: 'gallery',
      // animateNormal: 'tns-normal'
    });

    // append Pagination
    sliderPagination.innerHTML = paginationMarkup;

    // Pagination functionality
    sliderPagination.querySelectorAll('.o-stage__pagination-item')
      .forEach((value) => {
        const { slide } = value.dataset;
        const values = value;

        values.onclick = () => {
          stageSlider.goTo(slide);
        };
      });

    // set active Pagination status
    stageSlider.events.on('indexChanged', () => {
      const activeSlideIndex = stageSlider.getInfo().displayIndex;
      const activeSlidePagination = Slider.querySelectorAll('.o-stage__pagination-item')[activeSlideIndex - 1];

      // set Tabindex
      sliderWrapper.querySelectorAll('.a-link').forEach((v) => {
        const sliderLinks = v;

        sliderLinks.tabIndex = -1;
      });
      sliderWrapper.querySelector('.tns-slide-active .a-link').removeAttribute('tabindex');

      Slider.querySelectorAll('.o-stage__pagination-item')
        .forEach((value) => {
          value.classList.remove('active');
        });
      activeSlidePagination.classList.add('active');
    });

    // add Tab navigation for Slider
    /* eslint-disable */
    function checkTabPress(e) {
      e = e || event;
      let activeElement;
      if (e.keyCode === 9) {
        activeElement = document.activeElement;
        const focusedSlide = activeElement.closest('.o-stage__slider-element').dataset.slide;
        stageSlider.goTo(focusedSlide);
      }
    }
    /* eslint-enable */

    if (sliderElement) {
      const body = document.querySelector('.o-stage');
      document.querySelector('.o-stage__slider-controls').tabIndex = -1;
      body.addEventListener('keyup', checkTabPress);
    }

    // set same height
    setSameHeight();

    window.addEventListener('resize', setSameHeight);
  }
});
